// Not generated from samples: written from Appboy::Communication::Segment::DeviceOsVersionCodeFilter.

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceOsVersionCodeFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_os_version_code_filter"),
  // Constants::Comparisons.series_comparisons
  comparison_key: z.enum(["1", "2", "3", "4", "5", "6"]),
  // The platform the version belongs to: id is the Constants::Platforms token ("ios") and value
  // its app class TYPE ("iOS").
  display_name: z.object({
    id: z.string(),
    value: z.string(),
  }),
  // Only present when the filters_include_raw_values feature flipper is on. The OS version.
  raw_value: z.string().optional(),
  // id and value are both the OS version string, e.g. "18.0" or "Android (Android 11)".
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
